import React from 'react';

import type { StepListingsCompareFragment } from '@graphql/__generated__/graphql';
import ComparableListings from '@modules/comparable-listings/ComparableListings';
import ListingAutomatic from '@modules/reports/cma-reports/step-listing-compare/ListingAutomatic';
import type { SetHook } from '@shared/hooks/useSet';

interface ListingWrapperProps {
  mode: 'automatic' | 'manual';
  selection: SetHook<string | number>;
  onSelect: (id: string | number) => void;
  data?: StepListingsCompareFragment;
}

const ListingWrapper: React.FC<ListingWrapperProps> = ({
  mode,
  selection,
  onSelect,
  data,
}) => {
  if (mode === 'automatic' && data) {
    return (
      <ListingAutomatic selection={selection} onSelect={onSelect} data={data} />
    );
  } else if (mode === 'manual') {
    return (
      <ComparableListings
        selection={selection}
        onSelect={onSelect}
        lat={data?.property?.lat ?? null}
        lng={data?.property?.lng ?? null}
        stateId={data?.property?.state_place?.id ?? null}
        isDrawer={true}
      />
    );
  }
  return null;
};

export default ListingWrapper;
